<script setup>
import { useRouter } from 'vue-router';
import { useSlots, computed } from 'vue';
import NotificationBell from 'dashboard/components/layout/sidebarComponents/NotificationBell.vue';
import BackButton from 'dashboard/components/widgets/BackButton.vue';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  showBackButton: {
    type: Boolean,
    default: false,
  },
  backUrl: {
    type: [String, Object],
    default: '',
  },
  backButtonLabel: {
    type: String,
    default: '',
  },
  showNotificationBell: {
    type: Boolean,
    default: false,
  },
  hasMenuButton: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['openNotificationPanel']);

const router = useRouter();
const slots = useSlots();

const handleNotificationClick = () => {
  router.push({ name: 'notifications_index' });
};

const hasHeaderContent = computed(() => {
  return !!(slots['header-left'] || slots['header-right'] || props.showNotificationBell);
});
</script>

<template>
  <div class="w-full min-h-0 flex flex-col min-h-0 gap-6 xl:gap-1">
    <header :class="['flex items-center justify-between w-full py-3 pb-3 px-3 xl:px-6 sticky top-0 z-10', hasHeaderContent ? 'pt-4' : 'pt-6']">
      <div
        :class="[
          'flex-1 flex items-center gap-3',
          hasMenuButton ? 'ml-12 xl:ml-0' : 'ml-0',
        ]"
      >
        <BackButton
          v-if="showBackButton"
          compact
          :back-url="backUrl"
          :button-label="backButtonLabel"
        />
        <h1 class="!ml-0 text-base xl:text-lg font-semibold text-n-slate-12 dark:text-n-gray-3 truncate">
          {{ title }}
        </h1>
      </div>

      <div v-if="hasHeaderContent" class="flex items-center gap-3 h-10">
        <slot name="header-left" />
        <div class="flex items-center" v-if="showNotificationBell">
          <NotificationBell @open-notification-panel="handleNotificationClick" />
        </div>
        <slot name="header-right" />
      </div>
    </header>
    <section class="flex-1 px-3 xl:px-6 overflow-auto">
      <slot />
    </section>
  </div>
</template>